import { defaultConfig, prodConfig, qaConfig } from '../../../../config';

let thisConfig = qaConfig;
if (process.env.NODE_ENV === 'production') {
  thisConfig = prodConfig;
}

export const env = {
  nmxTemplateVersion: '3.18.1', // NOTE: used in other doc configs, please replace all
  ...defaultConfig,
  ...thisConfig,
  public: {
    ...(defaultConfig.public || {}),
    ...(thisConfig.public || {}),
  },
  services: {
    ...(defaultConfig.services || {}),
    ...(thisConfig.services || {}),
  },
};
